export const DRIVER_SURCHARGE_TYPE_DAY = 1
export const DRIVER_SURCHARGE_TYPE_MONTH = 2